import { render, staticRenderFns } from "./SmileyButtons.vue?vue&type=template&id=3ee60ffc&scoped=true"
import script from "./SmileyButtons.vue?vue&type=script&lang=ts"
export * from "./SmileyButtons.vue?vue&type=script&lang=ts"
import style0 from "./SmileyButtons.vue?vue&type=style&index=0&id=3ee60ffc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee60ffc",
  null
  
)

export default component.exports